// declare let Masonry: any;

import Masonry from 'masonry-layout';

export function activateMasonry() {
    const newsListElement = document.querySelector('.news-list-view');
        
    if (!newsListElement) {
        return;
    }

    var newslist = document.querySelector('.news-list-view');
    if (newslist) {
        // Check if Masonry is available
        if (typeof Masonry === 'undefined') {
            console.error('Masonry is not defined');
            return;
        }

        var msnry = new Masonry(newslist, {
            // options
            itemSelector: '.news-list-view .article',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            horizontalOrder: true,
        });
    }
}
